import { Link } from "@quintype/components";
import React, { useState, useEffect } from "react";

// import { hasSubscription } from "@/utils/actions";
// import { useAuthContext } from "@/app/context/AuthProvider";
// import { useEffect, useState } from "react";
// import { Subscription } from "@/store/Subscription";
import { AppealBoxPatron, AppealBoxSubscriber } from "../../utils/gtm";

export default function AppealBox() {
  const [appealBoxData, setShowAppealBox] = useState(null);
  // const { hasSubs } = Subscription();
  // const { isSubscribed } = useAuthContext();
  // const [show, setShow] = useState(true);

  // useEffect(() => {
  //   async function setShowAppealBox() {
  //     try {
  //       let hasSubs = await hasSubscription(user.email);
  //       setShow(hasSubs ? false : true);
  //     } catch (e) {
  //       console.error(`Error fetching subscription for ${user.email}:`, e);
  //     }
  //   }
  //   user ? setShowAppealBox() : setShow(true);
  // }, [user]);

  const getAppealData = async () => {
    try {
      let url = `https://subsapi.swarajyamag.com/api/appeal-box?populate=*`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      return data.data.attributes;
    } catch (error) {
      console.error(`Error while fetching data for appeal box`, error.message);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const data = await getAppealData();
      setShowAppealBox(data);
    }
    fetchData();
  }, []);
  return (
    <>
      {appealBoxData?.show_appeal_box ? (
        <div className="swarajya_patron_block px-[24px] mobile:px-0 ">
          <div className="subscribe_block_wrapper bg-[#ececec] dark:bg-zinc-800 dark:text-[#f1f1f1] p-[20px]">
            <p className="text-[20px] font-bold">{appealBoxData.title}</p>
            <hr className="  mt-1 h-[4px] w-[50%] border-none bg-primary" />
            <div className={"block_msg"}>
              <div
                className="appeal_body"
                dangerouslySetInnerHTML={{
                  __html: appealBoxData.body,
                }}
              ></div>
            </div>
            {/* <div className="block_buttons" style={{ display: "flex", justifyContent: "space-evenly" }}> */}
            <div className="flex flex-col items-center sm:flex-row sm:justify-evenly">
              <div>
                <Link href={appealBoxData.Buttons[0].redirect_url} target="_blank" aria-label="patron_subscribe_btn">
                  <button
                    type="button"
                    className="mt-6 w-48 rounded-sm border border-transparent bg-primary px-3 py-2 font-satoshi text-sm text-white transition-all focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                    style={{ boxShadow: "0 5px 10px rgba(0, 0, 0, 0.34)" }}
                    onClick={AppealBoxPatron}
                  >
                    {appealBoxData.Buttons[0].button_text}
                  </button>
                </Link>
              </div>
              <div>
                <Link href={appealBoxData.Buttons[1].redirect_url} target="_blank" aria-label="subscribe_btn">
                  <button
                    type="button"
                    className="mt-6 w-48 rounded-sm border border-transparent bg-primary px-3 py-2 font-satoshi text-sm text-white shadow-2xl transition-all focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                    style={{ boxShadow: "0 5px 10px rgba(0, 0, 0, 0.34)" }}
                    onClick={AppealBoxSubscriber}
                  >
                    {appealBoxData.Buttons[1].button_text}
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <style>{`
            .appeal_body {
              font-size: 16px;
              margin-top: 5px;
              line-height: 1.5;
            }
          `}</style>
        </div>
      ) : null}
    </>
  );
}
